import { Link } from "react-router-dom";
import {
  ADDRESS,
  BUSINESS_HOURS,
  EMAIL,
  GOOGLE_MAPS_LINK,
  INSTAGRAM_HANDLE,
  INSTAGRAM_LINK,
  LOGO_URL,
  PHONE_DISPLAY,
  PHONE_TEL,
  TRIPADVISOR_LINK,
  WHATSAPP_LINK,
} from "@/pages/home/constants";

const SERVICE_LINKS = [
  { to: "/passeio-de-lancha-capitolio", label: "Passeio de Lancha em Capitólio" },
  { to: "/aluguel-de-lancha-capitolio", label: "Aluguel de Lancha em Capitólio" },
  { to: "/passeio-de-jet-ski-capitolio", label: "Passeio de Jet Ski em Capitólio" },
];

export default function LandingFooter() {
  return (
    <footer className="relative bg-primary-900">
      <div className="w-full px-4 md:px-6 lg:px-8 py-7 md:py-10">
        <div className="max-w-[1500px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 mb-6">
            <div>
              <div className="mb-3">
                <img
                  src={LOGO_URL}
                  alt="Eco Tour Turismo — Passeios de Lancha em Capitólio"
                  title="Eco Tour Turismo Capitólio"
                  className="h-16 w-auto object-contain"
                />
              </div>
              <p className="text-[11px] text-white/50 leading-relaxed max-w-xs">
                Especialistas em passeios de lancha e experiências náuticas em Capitólio, no coração do Mar
                de Minas. Conforto, segurança e atendimento personalizado.
              </p>
              <div className="flex items-center gap-2 mt-4">
                <a
                  href={WHATSAPP_LINK}
                  data-whatsapp-cta
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-xs" />
                </a>
                <a
                  href={INSTAGRAM_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-xs" />
                </a>
                <a
                  href={GOOGLE_MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-7 h-7 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-accent-500 hover:text-primary-950 transition-all duration-200 cursor-pointer"
                  aria-label="Google Maps"
                >
                  <i className="ri-map-pin-2-line text-xs" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xs font-semibold text-white/70 uppercase tracking-wider mb-3">
                <a href="/#embarque" className="hover:text-accent-300 transition-colors cursor-pointer">
                  Onde Estamos
                </a>
              </h4>
              <div className="space-y-2 text-[11px] text-white/50">
                <p className="flex items-start gap-1.5">
                  <i className="ri-map-pin-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a
                    href={GOOGLE_MAPS_LINK}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {ADDRESS}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-phone-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a href={`tel:${PHONE_TEL}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                    {PHONE_DISPLAY}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-mail-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <a href={`mailto:${EMAIL}`} className="hover:text-accent-300 transition-colors cursor-pointer break-all">
                    {EMAIL}
                  </a>
                </p>
                <p className="flex items-start gap-1.5">
                  <i className="ri-time-line text-accent-400 text-xs mt-0.5 flex-shrink-0" />
                  <span>{BUSINESS_HOURS}</span>
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-xs font-semibold text-white/70 uppercase tracking-wider mb-3">
                Nossos Passeios
              </h4>
              <div className="space-y-2 text-[11px]">
                {SERVICE_LINKS.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                ))}
                <Link
                  to="/"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Página Inicial
                </Link>
                <a
                  href={TRIPADVISOR_LINK}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block text-white/50 hover:text-accent-300 transition-colors duration-200 cursor-pointer"
                >
                  Avaliações no Tripadvisor
                </a>
                <span className="block text-white/40">Instagram {INSTAGRAM_HANDLE}</span>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[10px] text-white/40 text-center sm:text-left">
              © 2026 Eco Tour Turismo Capitólio — Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4">
              <p className="hidden sm:block text-[10px] text-white/40 text-center sm:text-right">
                Capitólio · MG — Mar de Minas
              </p>
              <Link
                to="/"
                aria-label="Voltar para a página inicial"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-[11px] font-bold text-white bg-white/10 border border-white/20 hover:bg-accent-500 hover:text-primary-950 hover:border-accent-500 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-home-4-line text-sm" />
                Voltar ao Início
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}